import { unwrapResult } from '@reduxjs/toolkit'
import { Col, Form, Modal, notification, Table } from 'antd'
import _, { sum } from 'lodash'
import React, { ReactElement, useContext, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { EditableList } from '../../../compnents/list/EditableList'
import { ThemeContext } from '../../../theme/ThemeContext'
import { Columns } from './column'
import { Query } from './Query'
import styles from './TIManagement.module.css'
import { AddOrEditFormModal } from './addOrEditModal'
import { getTIManagementListAsync, getRemoveAsync } from './TIManagementSlice'
import { ExclamationCircleFilled } from '@ant-design/icons'
import { useHistory, useLocation } from 'react-router-dom'

export const TIManagementList = (props: {
  selectKey?: string
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const location: any = useLocation()

  const history = useHistory()

  const theme = useContext(ThemeContext)

  const [isModalVisible, setIsModalVisible] = useState(false)

  const [editTenantId, setEditTenantId] = useState<any>()

  const [total, setTotal] = useState<any>()

  const [data, setData] = useState<any[]>([])

  const [id, setId] = useState<any>()

  const [isEdit, setIsEdit] = useState<any>()

  const [queries, setQueries] = useState<any>({
    current: 1,
    size: 10,
  })

  const [pageLoading, setPageLoading] = useState(false) // 表格 loading

  const getDataList = () => {
    setPageLoading(true)
    dispatch(getTIManagementListAsync({ ...queries }))
      .then(unwrapResult)
      .then((res: any) => {
        setData(res.records)
        setTotal(res.total)
      })
      .finally(() => setPageLoading(false))
  }

  useEffect(() => {
    if (props?.selectKey == '1' || location?.state?.selectKey == '1') {
      getDataList()
    }
  }, [queries, props?.selectKey])

  return (
    <Col className={styles.content}>
      <Col
        className={styles.contentMain}
        style={{
          flex: 1,
          backgroundColor: theme.pn,
        }}
      >
        <Query
          loading={pageLoading}
          add={() => {
            setIsModalVisible(true)
            setId('')
            setIsEdit('')
            setEditTenantId('')
          }}
          onValueChange={(v) => {
            setQueries({ ...queries, ...v, current: 1 })
          }}
        />
        <EditableList
          loading={pageLoading}
          page={{
            items: data,
            current: queries.current || 1,
            size: queries.size || 10,
            total: total,
          }}
          columns={Columns((text, t: any) => {
            if (text == 'delete') {
              Modal.confirm({
                centered: true,
                title: '确认操作',
                content: (
                  <div>
                    <ExclamationCircleFilled
                      style={{ color: '#FFAE55', fontSize: 18 }}
                    />
                    &nbsp;是否确认删除？
                  </div>
                ),
                okText: '确认',
                cancelText: '取消',
                icon: null,
                onOk: () => {
                  dispatch(getRemoveAsync(t.id))
                    .then(unwrapResult)
                    .then(() => {
                      notification.success({
                        message: '删除成功',
                      })
                      getDataList()
                    })
                },
              })
            } else if (text == 'edit') {
              setIsModalVisible(true)
              setId(t?.id)
              setEditTenantId(t?.tenantId)
              setIsEdit(t?.isEdit?.toString())
            } else if (text == 'detail') {
              history.push({
                pathname: '/TIManagementDetailList',
                state: {
                  trainingId: t?.id,
                  selectKey: props?.selectKey,
                  editTenantId: t?.tenantId,
                  isEditFlag: t?.isEdit?.toString()
                },
              })
            }
          }, (queries.size || 10) * ((queries.current || 1) - 1))}
          onChangePage={(current: any, size: any) => {
            setQueries({
              ...queries,
              current,
              size,
            })
          }}
          onRow={(r) => ({
            onDoubleClick: () => {
              setId(r.id)
            },
          })}
        />
      </Col>
      {/* 新增或编辑 */}
      <AddOrEditFormModal
        editTenantId={editTenantId}
        isEdit={isEdit}
        id={id}
        isModalVisible={isModalVisible}
        onCancel={() => {
          setIsModalVisible(false)
          setId('')
          setIsEdit('')
          setEditTenantId('')
        }}
        onOk={() => {
          setIsModalVisible(false)
          setId('')
          setIsEdit('')
          getDataList()
          setEditTenantId('')
        }}
      />
    </Col>
  )
}
